import React from 'react'
import Svg from '../Svg'
import { SvgProps } from '../types'

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 26 23" {...props}>
      <path d="M0 0V1.26667C0 4.76979 1.44479 7.29818 2.74609 9.2526C4.0474 11.207 5.06667 12.5974 5.06667 13.9333H7.6C7.6 13.9135 7.59505 13.8938 7.59505 13.874C8.83203 16.6794 10.1333 17.7333 10.1333 17.7333H15.2C15.2 17.7333 16.5013 16.6794 17.7383 13.874C17.7383 13.8938 17.7333 13.9135 17.7333 13.9333H20.2667C20.2667 12.5974 21.2859 11.207 22.5872 9.2526C23.8885 7.29818 25.3333 4.76979 25.3333 1.26667V0H0ZM2.77578 2.53333H5.41302C5.49219 5.58125 5.84844 8.07995 6.34323 10.0987C5.87318 9.33177 5.3487 8.58958 4.85391 7.8474C3.83464 6.32344 3.06276 4.63125 2.77578 2.53333ZM7.98594 2.53333H17.3523V3.8H17.3424C16.9466 10.638 15.0021 13.9828 14.0917 15.2H11.2516C10.3164 13.9531 8.38177 10.6034 7.98594 3.8V2.53333ZM19.9203 2.53333H22.5576C22.2706 4.63125 21.4987 6.32344 20.4794 7.8474C19.9846 8.58958 19.4602 9.33177 18.9901 10.0987C19.4849 8.07995 19.8411 5.58125 19.9203 2.53333ZM6.33333 20.2667V22.8H19V20.2667H6.33333Z" />
    </Svg>
  )
}

export default Icon
